import { render, staticRenderFns } from "./MessageSettingsTable.vue?vue&type=template&id=089657d2&"
import script from "./MessageSettingsTable.vue?vue&type=script&lang=js&"
export * from "./MessageSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports